import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation, ViewChild, ElementRef} from '@angular/core';
import {LocusDetailsDto} from "../../../models/locus-details-dto";
import {SurroundingLociDetailsDto} from "../../../models/surrounding-loci-details-dto";
import {ImageDto} from 'src/app/models/image-dto';
import {LicenseDto} from "../../../models/license-dto";
import { ScreenDimensionsService } from 'src/app/services/screen-dimensions.service';
import { RoutingService } from 'src/app/services/routing.service';
import { Button } from 'primeng/button';
import { set } from 'lodash';
import { Observable } from 'rxjs';
export class SurroundingLociDto {
  constructor(
    public lociAbove: SurroundingLociDetailsDto[],
    public lociCutBy: SurroundingLociDetailsDto[],
    public lociBelow: SurroundingLociDetailsDto[],
    public lociCutsInto: SurroundingLociDetailsDto[],
    public lociAdjointsInto: SurroundingLociDetailsDto[]
  ) {
  }
}
@Component({
  selector: 'locus-details',
  templateUrl: './locus-details.component.html',
  styleUrls: ['./locus-details.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class LocusDetailsComponent implements OnInit, OnChanges {
  protected readonly Array = Array;
  @Input() selectedLocus!: LocusDetailsDto;
  @Input() currentLanguage!: Observable<string>;
  @Input() isLoading!: boolean;
  @ViewChild('detailsElement') detailsElement!: ElementRef;

  descriptionDirection: 'ltr' | 'rtl' | 'auto' = 'rtl';
  HebrewChars = new RegExp("^[\u0590-\u05FF]+$");
  isSmallScreen = false;
  sorroundingLociCount = 0;

  images: ImageDto[] = [];
  thumbnails:  any | ImageDto[] | undefined = [];

  constructor(private screenDimensionsService: ScreenDimensionsService, private routingService: RoutingService) {
  }
  ngAfterViewInit() {
    const details = this.detailsElement?.nativeElement;

    details?.addEventListener('toggle', () => {
      if (details.open && this.isSmallScreen) {
        setTimeout(() => {
        details.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 0);
      }
    });
  }
  ngOnInit(): void {
    this.screenDimensionsService.isSmallScreen$.subscribe(isSmallScreen => {
      this.isSmallScreen = isSmallScreen;
    });
    if (this.HebrewChars.test(this.selectedLocus?.locusDescription[0])){
      this.descriptionDirection = 'rtl';
    }
    else this.descriptionDirection = 'ltr';
    this.sorroundingLociCount = Object.values(this.selectedLocus?.surroundingLoci || {}).reduce((acc, curr) => acc + curr.length, 0);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedLocus']?.currentValue) {
      this.images = this.selectedLocus?.images || [];
                this.thumbnails = this.images .map(img => ({
            ...img,
            imageUrl: img.imageUrl.includes('?') 
              ? img.imageUrl + '&type=thumbnail'
              : img.imageUrl + '?type=thumbnail'
          }));
    }
  }

  getNames(items: SurroundingLociDetailsDto[]) {
    return items.map((e: SurroundingLociDetailsDto) => e.locusName).join(', ');
  }

  getEntityId(items: SurroundingLociDetailsDto[]) {
    return items.map((e: SurroundingLociDetailsDto) => e.locusId).join(', ');
  }

  goToLocus(locusId: number): void {
    this.routingService.navigateWithMerge({entityId: locusId, entityType: 'locus'});
  }
  getLicencesListNames(locusLicenses: LicenseDto[] | undefined) {
    return locusLicenses ? locusLicenses.map(l => l.longName).join(", ") : "";
  }

}
